exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-components-globe-___GlobeWrapper__wrapper___2q3u7 {\n  top: 0;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n}\n\n.src-components-globe-___GlobeWrapper__wrapper___2q3u7 > canvas {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  touch-action: none;\n  cursor: move;\n}", ""]);

// exports
exports.locals = {
	"wrapper": "src-components-globe-___GlobeWrapper__wrapper___2q3u7"
};